/* 🤖 this file was generated by svg-to-ts */
export const iconReturn: {
    name: 'return';
    data: string;
} = {
    name: 'return',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path fill="#000" fill-rule="evenodd" d="M14.76.76C20.957.76 26 5.801 26 12s-5.042 11.24-11.24 11.24a11.14 11.14 0 0 1-8.149-3.497.668.668 0 1 1 .968-.92 9.82 9.82 0 0 0 7.18 3.082c5.461 0 9.905-4.444 9.905-9.905 0-5.462-4.444-9.904-9.905-9.904-5.246 0-9.553 4.099-9.885 9.263l2.658-2.365a.668.668 0 1 1 .887.998l-3.86 3.437a.67.67 0 0 1-.445.169l-.04-.001a.67.67 0 0 1-.46-.224L.17 9.501a.668.668 0 1 1 .998-.888l2.374 2.667C3.913 5.417 8.8.76 14.759.76"/></svg>`
};
